<template>
    <div>
        <header class="page-header"><h2>Noticias & Anuncios</h2></header>
        <section class="card card-dashboard">
            <div class="card-header bg-info">
                <h3 class="my-0">Noticias & Anuncios</h3>
            </div>
            <div class="card-body">
                <div v-for="item in records" :key="item.id" class="mb-2 p-2 border rounded bg-light">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                        <div class="font-weight-bold">{{ item.title }}</div>
                        <small class="text-muted">{{ item.created_at }}</small>
                    </div>
                    <div>{{ item.message }}</div>
                    <a :href="`/dashboard/communications/view/${item.id}`" class="text-info ml-1">Leer más</a>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    data() {
        return { records: [] }
    },
    created() {
        this.$http.get('/dashboard/communications/announcements/records').then(r => {
            if (r.data.success) this.records = r.data.data || []
        })
    }
}
</script>


// WEBPACK FOOTER //
// modules/Dashboard/Resources/assets/js/views/communications_announcements.vue